var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 49 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.604 0 7.264 5.826c-4.226 2.25-9.113 7.812-10.302 12.578.396-.265 1.585-.397 2.641-.397 5.02 0 8.982 3.84 8.982 9.533S17.434 38 11.755 38C5.547 38 0 33.101 0 24.495 0 14.565 5.415 5.693 13.604 0Zm26.811 0 7.396 5.826c-4.226 2.25-9.245 7.812-10.302 12.578.397-.265 1.585-.397 2.642-.397 4.887 0 8.849 3.84 8.849 9.533S44.377 38 38.566 38c-6.208 0-11.623-4.899-11.623-13.505 0-9.93 5.283-18.802 13.472-24.495Z",
  fill: "currentColor"
})));
export default SvgQuote;